export function formatPlayerHeight(value: unknown): string | undefined {
  const raw = String(value ?? "").trim();
  if (!raw) return undefined;

  const formattedMatch = raw.match(/^(\d{1})'(\d{1,2})"?$/);
  if (formattedMatch) {
    const feet = Number(formattedMatch[1]);
    const inches = Number(formattedMatch[2]);
    if (Number.isFinite(feet) && Number.isFinite(inches)) {
      return `${feet}'${inches}"`;
    }
  }

  const totalInches = Number(raw);
  if (!Number.isFinite(totalInches) || totalInches <= 0) return undefined;

  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  return `${feet}'${inches}"`;
}
